import CreationModal from "components/CreationModal"
import Frame from "components/base/Frame"

const Newsletter = () => {
    return (
        <Frame>
            <div className="m-auto max-w-screen-lg justify-between block flex items-center">
                <CreationModal state={"campaign"} />
            </div>
        </Frame>
    )
}

export default Newsletter
